import {useContext, useEffect, useState} from "react";

import {ProductDataContext} from "contexts/productDataContext";
import PriceFilterPanel from "views/marketplace/merchandising/filter/priceFilterPanel";
import SalesFilterPanel from "views/marketplace/merchandising/filter/salesFilterPanel";
import StatusFilterPanel from "views/marketplace/merchandising/filter/statusFilterPanel";
import {SCORING_FILTER_GROUPS} from "views/marketplace/merchandising/filter/scoringFilterGroups";

// The filter tabs of the product lists (merchandising, enrichment), built once every
// ProductDataContext source is loaded.
export default function useMerchandisingFilterTabs() {
    const [filters, setFilters] = useState([]);
    const [filtersLoaded, setFiltersLoaded] = useState(false);
    const {categoriesLoaded, categoriesFilters,
        retailersLoaded, retailersFilters,
        cornersLoaded, cornersFilters,
        statusLoaded, statusFilters,
        gendersLoaded, gendersFilters,
        optionsLoaded, optionsFilters,
        brandsLoaded, brandsFilters,
        channelsLoaded, channelsFilters
    } = useContext(ProductDataContext);

    useEffect(() => {
        if (categoriesLoaded &&
            retailersLoaded &&
            cornersLoaded &&
            statusLoaded &&
            gendersLoaded &&
            brandsLoaded &&
            channelsLoaded &&
            optionsLoaded
        ) {
            setFiltersLoaded(true)

            let finalFilters = [
                categoriesFilters,
                retailersFilters,
                cornersFilters,
                statusFilters,
                gendersFilters,
                brandsFilters,
                // free numeric inputs (min/max price and discount), right after the brands
                {tabTitle: "price", tabContent: {component: PriceFilterPanel, items: []}},
                // free numeric input (minimum online sales)
                {tabTitle: "sales", tabContent: {component: SalesFilterPanel, items: []}},
                // two exclusive chip groups (benchmark / demand level), Status-tab layout
                {tabTitle: "scoring", tabContent: {component: StatusFilterPanel, items: SCORING_FILTER_GROUPS}},
                optionsFilters
            ];

            if (channelsFilters.tabContent.items.length > 1) {
                // add channels filters before options filters
                let indexBeforeLast = finalFilters.length - 1;
                finalFilters.splice(indexBeforeLast, 0, channelsFilters);
            }

            setFilters(finalFilters);
        }
    }, [
            categoriesLoaded,
            retailersLoaded,
            cornersLoaded,
            statusLoaded,
            gendersLoaded,
            brandsLoaded,
            channelsLoaded,
            optionsLoaded
        ]
    );

    return {filters, filtersLoaded};
}
